<template>
  <div class="work-item">
    <div v-if="item" class="">
      <div class="work-item-body">
        <h4>{{ item.title }}</h4>
        <p>{{ item.description }}</p>
        <div>
          <div class="row">
            <div
              v-if="!item.discipline.category.disable_timetable"
              class="col-6"
            >
              <selector
                :setLink="`business/teacher_groups/${item.group.id}/journals/${item.discipline.id}/timetables`"
                modal="timetable"
                title="Выберите день "
                v-model="timetable"
                :selectKey="`date`"
                :prefix="`timetable`"
              />
            </div>
            <div class="col-12">
              <star-rating v-model="item.rate"></star-rating>
            </div>
          </div>
          <div class="mt-4">
            <button
              @click="createRating"
              class="btn btn-sm btn-success btn-icon"
            >
              Поставить
            </button>
          </div>
        </div>
        <hr />
        <h5>Начат: {{ item.start_at | dateTimeFormat }}</h5>
        <h5>Завершен: {{ item.done_at | dateTimeFormat }}</h5>
        <h5>Отвечено: {{ decision_count }}/{{ work_count }}</h5>
        <h5>Правильно: {{ true_count }}/{{ test_work_count }}</h5>
        <hr />
        <template v-for="(work, key) in item.data">
          <div class="work" v-if="work.type" :key="key">
            <h4 class="work-title">
              <span class="text-info"> {{ key + 1 }}.</span> {{ work.title }}
              {{ work.type }}
              <span
                v-if="work.decisions && !work.decisions.length"
                class="badge badge-danger"
                >Не ответил</span
              >
            </h4>
            <p class="work-description" v-html="work.description"></p>
            <component
              class="work-content"
              :is="`decision-${work.type}`"
              :work="work"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { errorNotify } from "@/plugins/functions";
import { setRating } from "@/_api/apiPupil";

export default {
  computed: {
    decision_count() {
      let count = 0;
      for (let i = 0; i < this.item.data.length; i++) {
        if (this.item.data[i]["decisions"].length) {
          count++;
        }
      }
      return count;
    },
    work_count() {
      return this.item.data.length;
    },

    test_work_count() {
      let count = 0;
      for (let i = 0; i < this.item.data.length; i++) {
        if (
          this.item.data[i]["type"] === "glue" ||
          this.item.data[i]["type"] === "order" ||
          this.item.data[i]["type"] === "test"
        ) {
          count++;
        }
      }
      return count;
    },
    true_count() {
      let count = 0;
      for (let i = 0; i < this.item.data.length; i++) {
        ///////////////////GLUE
        if (this.item.data[i]["type"] === "glue") {
          let trueCount = 0;

          let answers = this.item.data[i]["answers"];
          let decision = this.item.data[i]["decisions"];
          let answerCount = answers.length;

          for (let d = 0; d < decision.length; d++) {
            let one = decision[d]["answer_id"];
            let two = decision[d]["answer"];
            let groupOne = "01";
            let groupTwo = "02";
            for (let a = 0; a < answerCount; a++) {
              if (answers[a]["id"] == one) {
                groupOne = answers[a]["group_symbol"];
              }
              if (answers[a]["id"] == two) {
                groupTwo = answers[a]["group_symbol"];
              }
            }

            if (groupOne == groupTwo) {
              trueCount++;
            }
          }

          if (trueCount == answerCount / 2 && decision.length > 0) {
            count++;
          }
        }

        ///////////////////TEST
        if (this.item.data[i]["type"] === "test") {
          let trueAnswer = true;
          let decision = this.item.data[i]["decisions"];
          for (let d = 0; d < decision.length; d++) {
            if (decision[d]["answer_true"] === 0) {
              trueAnswer = false;
            }
          }
          if (trueAnswer === true && decision.length > 0) {
            count++;
          }
        }

        ///////////////////ORDER
        if (this.item.data[i]["type"] === "order") {
          let decision = this.item.data[i]["decisions"];
          let answers = this.item.data[i]["answers"];
          let answerCount = answers.length;
          let trueAnswer = true;

          for (let d = 0; d < decision.length; d++) {
            if (decision[d]["answer"] != d) {
              trueAnswer = false;
            }
          }
          if (trueAnswer === true && decision.length === answers.length) {
            count++;
          }
        }
      }
      return count;
    },
  },
  name: "decision",
  components: {},
  methods: {
    setRating: setRating,
    createRating() {
      let params = {
        work: this.item.work,
        value: this.item.rate ? this.item.rate : 0,
        client: this.item.client,
      };

      if (
        this.item.discipline &&
        this.item.discipline.category &&
        !this.item.discipline.category.disable_timetable
      ) {
        params["timetable_id"] = this.timetable ? this.timetable.id : null;
      }

      this.setRating(params, "post");
    },
    async getData() {
      this.$loading(true);
      this.item = await this.$http
        .get(`business/processes/${this.id}`)
        .then((response) => {
          this.timetable = response.data.timetable;
          return response.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  async created() {
    this.getData();
  },
  props: {
    id: {
      default: null,
    },
  },
  data() {
    return {
      item: null,
      value: 0,
      rate: null,
      timetable: null,
    };
  },
};
</script>
<style lang="scss">
.work {
  margin-bottom: 20px;
  border-bottom: 1px solid #ebebeb;

  &:last-child {
    border-bottom: none;
  }

  padding: 0 0 15px 0;
}
</style>


